const approvedStyle = ({ breakpoints }) => ({
  background: "#1AAE6F1A !important",
  borderColor: "#1AAE6F1A !important",
  color: "#1AAE6F !important",
})

const rejectedStyle = ({ breakpoints }) => ({
  background: "#EF39481A !important",
  borderColor: "#EF39481A !important",
  color: "#EF3948 !important",
})

const pendingStyle = ({ breakpoints }) => ({
  background: "#FF95001A !important",
  borderColor: "#FF95001A !important",
  color: "#FF9500 !important",
})

export const alertChipStyle = (status, theme) => {
  const normalized = String(status || "").toUpperCase()
  switch (normalized) {
    case "APPROVED":
      return approvedStyle(theme)
    case "REJECTED":
      return rejectedStyle(theme)
    case "PENDING":
      return pendingStyle(theme)
    default:
      return pendingStyle(theme)
  }
}
